<template>
  <SearchCep/>
</template>

<script>
import SearchCep from "./components/SearchCep.vue";


export default {
  name: "App",
  components: {
    SearchCep,
  },
};
</script>

<style>
*{
  margin: 0;
  padding: 0;
  font-family: sans-serif;
}
</style>
